import React from 'react';
import { Link } from 'react-router';

const LandSearchGridItem = (props) => {
    let lotStatus = <span className="fcolor-gr">Available</span>;
    if(props.data.status === 2) {
        lotStatus = <span className="fcolor-gray">Sold</span>;
    }
    if(props.data.status === 3) {
        lotStatus = <span className="fcolor-bl">Builders Excl.</span>;
    }
    return (
            <div className="w-100 w-50-md w-33-lg w-25-wd fl p-a-1-md p-b-1">

                <Link to={props.data.link}>
                    <img className="select-package-image" src={props.data.image} alt=""/>
                </Link>


                <div className="river-select-package-text">
                    <div className="cf m-b-05 m-t-05 tc tl-md">
                        <Link to={props.data.link}>
                            <p className="select-package-header small-blue-font m-b-1">LOT {props.data.name} - {lotStatus}</p>
                        </Link>
                    </div>

                    <div className="cf m-b-05">
                        <div className="fl w-50 tl">
                            <p className="small-grey-font fcolor-og">{props.data.stage}</p>
                        </div>

                                    <div className="fr w-50 tr">
                                        <p className="small-grey-font">{props.data.packages} Packages</p>
                                    </div>
                                </div>

                                <div className="cf p-b-1 m-b-1 brd-bottom">

                    <div className="fl w-50 tl">
                        <p className="small-grey-font">Land Size<span className="fcolor-og small-grey-font"> {props.data.area}m<sup>2</sup></span></p>
                    </div>

                    <div className="fr w-50 tr">
                        <p className="small-grey-font">Frontage<span className="fcolor-og small-grey-font"> {props.data.frontage}m</span></p>
                    </div>
                </div>

                <div className="cf m-b-05">
                    <div className="fl w-50 select-package-download-icon">
                        <a className="download-flyer" href={props.data.pdf} target="_blank">
                            <i className="icon icon--download-alt"></i>
                            <span className="small-grey-font">Download Flyer</span>
                        </a>
                    </div>

                    <div className="fr w-50">
                        <a className="btn btn__enquire js-modalOpen fr" role="button" href="#" data-toggle="modal" data-target="#RegisterModal">
                            <span className="btn-land-available">ENQUIRE</span>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default LandSearchGridItem;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LandSearchGridItem.js
 **/